import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex items-center justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", {
  class: "hidden sm:inline-block sm:align-middle sm:h-screen",
  "aria-hidden": "true"
}, "​", -1)
const _hoisted_3 = { class: "inline-block align-bottom bg-white rounded-lg px-4 pt-5 pb-4 text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-6xl sm:w-full sm:p-6" }
const _hoisted_4 = { class: "mt-2 text-center sm:mt-5" }
const _hoisted_5 = { class: "mt-6 pb-2 text-left overflow-x-auto" }
const _hoisted_6 = { class: "mt-5 sm:mt-6" }

import { computed } from "vue";
import { Dialog, DialogTitle, DialogOverlay, TransitionRoot, TransitionChild } from "@headlessui/vue";
import DataTable from "../tools/DataTable.vue";
import dayjs from "dayjs";
import { formatNumber, translate } from "@/utils/tools";
import { useRouter } from "vue-router";


export default /*#__PURE__*/_defineComponent({
  __name: 'CommissionSummaryDialog',
  props: {
  userData: Array, 
  show: Boolean
},
  emits: ["submit", "update:show", "update:form"],
  setup(__props, { emit }) {

const props = __props

const router = useRouter();





const columns = computed(() => {
  const hasValidBet = props.userData?.some(item => item?.hasOwnProperty('total_valid_bet'));
  return [
    {
      label: translate("messages.commissionSummary.commission"),
      field: "commission_amount",
      isSorted: false,
      format: (data: any) => formatNumber(data.commission_amount),
      class: (data: any) => "text-green-500 font-bold",
    },
    {
      label: hasValidBet ? translate("messages.commissionSummary.validBet") : translate("messages.commissionSummary.bet"),
      field: "total_valid_bet",
      isSorted: false,
      format: (data: any) => hasValidBet ? formatNumber(data.total_valid_bet) : formatNumber(data.total_bet),
    },
    {
      label: translate("messages.commissionSummary.startDate"),
      field: "start_date",
      isSorted: false,
      format: (data: any) => dayjs(data.start_date).format("YYYY-MM-DD HH:mm:ss"),
    },
    {
      label: translate("messages.commissionSummary.endDate"),
      field: "end_date",
      isSorted: false,
      format: (data: any) => dayjs(data.end_date).format("YYYY-MM-DD HH:mm:ss"),
    },
  ];
});

const showSync = computed({
  get: () => props.show,
  set: (value) => emit("update:show", value),
});

const viewUser = (data: any) => {
  const userId = data.userId; 
  router.push({ name: "Wallet Info", params: { id: userId } });
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_unref(TransitionRoot), {
      as: "template",
      show: _unref(showSync),
      static: ""
    }, {
      default: _withCtx(() => [
        _createVNode(_unref(Dialog), {
          as: "div",
          static: "",
          class: "fixed z-10 inset-0 overflow-y-auto",
          onClose: _cache[2] || (_cache[2] = ($event: any) => (showSync.value = false)),
          open: _unref(showSync)
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_1, [
              _createVNode(_unref(TransitionChild), {
                as: "template",
                enter: "ease-out duration-300",
                "enter-from": "opacity-0",
                "enter-to": "opacity-100",
                leave: "ease-in duration-200",
                "leave-from": "opacity-100",
                "leave-to": "opacity-0"
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(DialogOverlay), { class: "fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" })
                ]),
                _: 1
              }),
              _hoisted_2,
              _createVNode(_unref(TransitionChild), {
                as: "template",
                enter: "ease-out duration-300",
                "enter-from": "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95",
                "enter-to": "opacity-100 translate-y-0 sm:scale-100",
                leave: "ease-in duration-200",
                "leave-from": "opacity-100 translate-y-0 sm:scale-100",
                "leave-to": "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_3, [
                    _createElementVNode("div", null, [
                      _createElementVNode("div", _hoisted_4, [
                        _createVNode(_unref(DialogTitle), {
                          as: "h3",
                          class: "text-lg leading-6 font-medium text-gray-900"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t("messages.commissionSummary.details")) + " ", 1),
                            _createElementVNode("span", {
                              class: "text-sm text-blue-500 pl-1",
                              onClick: _cache[0] || (_cache[0] = ($event: any) => (viewUser(__props.userData)))
                            }, "( " + _toDisplayString(_ctx.$t("messages.commissionSummary.viewUser")) + ")", 1)
                          ]),
                          _: 1
                        }),
                        _createElementVNode("div", _hoisted_5, [
                          _createVNode(DataTable, {
                            class: "mx-auto",
                            columns: _unref(columns),
                            data: __props.userData
                          }, null, 8, ["columns", "data"])
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_6, [
                      _createElementVNode("button", {
                        type: "button",
                        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('submit'))),
                        class: "mt-3 w-full inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 sm:mt-0 sm:col-start-1 sm:text-sm"
                      }, _toDisplayString(_ctx.$t("messages.commissionSummary.close")), 1)
                    ])
                  ])
                ]),
                _: 1
              })
            ])
          ]),
          _: 1
        }, 8, ["open"])
      ]),
      _: 1
    }, 8, ["show"])
  ]))
}
}

})